import { Reveal } from "@/components/Reveal";
import { Eyebrow } from "@/components/BrandGeometry";

export default function Standards() {
  return (
    <section id="standards" className="border-b border-line bg-cream">
      <div className="mx-auto max-w-7xl px-6 py-24 sm:px-10 sm:py-32 lg:px-16">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <Reveal>
              <Eyebrow>Standards</Eyebrow>
              <h2 className="mt-6 font-display text-4xl font-medium leading-tight tracking-tight text-navy sm:text-5xl">
                Committed to responsible fundraising
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-8">
            <Reveal delay={0.1}>
              <div className="border border-line bg-white p-8 sm:p-10">
                <div className="mb-6 h-1 w-12 bg-brand-green" aria-hidden="true" />
                <p className="text-lg leading-relaxed text-slate-body sm:text-xl">
                  Amanah Promotions is committed to ethical, responsible fundraising and compliance
                  with the Code of Fundraising Practice. Our campaigns are supported by appropriate
                  training, oversight, quality assurance and safeguards for members of the public.
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
